import { SESSION_STATUS } from './sessionConstants';

export const createRootReducer = (appReducer) => (state, action) => {
    if (action.type === 'session/sessionEnded') {
        const theme = state?.theme;
        const resetState = appReducer(undefined, action);

        return {
            ...resetState,
            currentUser: {
                ...resetState.currentUser,
                ...(state?.currentUser?._persist ? { _persist: state.currentUser._persist } : {}),
            },
            ...(theme ? { theme } : {}),
            session: { status: SESSION_STATUS.ANONYMOUS },
        };
    }

    return appReducer(state, action);
};
